module.exports = __webpack_public_path__ + "static/img/8.0235766.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/zh/8.png
// module id = A803
// module chunks = 0